import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject } from 'rxjs';
import { UserPrivileges, UserRoleConstants } from 'src/app/constants/AppConstants';
import { RoutesConstants } from 'src/app/constants/RoutesConstants';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CommonServiceService } from 'src/app/services/common-service.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-mortgage-plots',
  templateUrl: './mortgage-plots.component.html',
  styleUrls: ['./mortgage-plots.component.scss']
})
export class MortgagePlotsComponent implements OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  mortgagePlots: any = [];
  userInfo: any;
  popup = true;
  releasingMortgagePlot: any;
  closeResult = '';
  error: boolean;
  errorMessage: any;
  ventureId: any;
  userPrivileges = UserPrivileges;

  constructor(
    private restService: RestService,
    public commonService: CommonServiceService,
    private authService: AuthServiceService,
    private modalService: NgbModal,
    private permissionsService: NgxPermissionsService,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.ventureId = this.commonService.getVenture()?.ventureId;

    this.fetchMortgagePlots();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      bPaginate: false,
      bInfo: false,
      searching: false,
    };

  }

  fetchMortgagePlots(){

    this.userInfo = this.authService.getUserInfo();

    let url = 'plot/get-mortgage-plots?ventureId=' + this.ventureId;

  this.dtTrigger.next();
    this.restService.getMortgagePlots(url).subscribe(response => {
      if (response != null && response != undefined) {
        this.mortgagePlots = response.data;

        if (this.authService.hasRole(UserRoleConstants.TENANT)) {
          this.permissionsService.hasPermission(UserPrivileges.TENANT_PRIVILEGE).then(hasTenantPrivilege => {
            if (hasTenantPrivilege) {
              this.popup = false;      
            }
          });
        }

      }
    },
    (error) => {
      console.log(error.status);
    });
  }

  capitalFirst(type) {
    const mySentence = type;
    return mySentence.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  }

  open(content, plot) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.releasingMortgagePlot = plot;
  }

  private getDismissReason(reason: any): string {

    return `with: ${reason}`;

  }

  openReleaseAlert(releaseContent){

    if (this.mortgagePlots && this.mortgagePlots.length > 0) {
      this.modalService.open(releaseContent, { ariaLabelledBy: 'modal-basic-title' }).result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
    }

  }



  goToMarkPlotsToMortgage(){
    this.router.navigate(['/'+this.commonService.getUrlSuffix(), RoutesConstants.VENTURELAYOUT, RoutesConstants.MORTGAGEMARKING]);
  }


  releaseMortgagePlots() {
    const plotIdList = this.mortgagePlots.map(plot => plot.plotId);
    
    const requestData = {
        plotIdList: plotIdList
    };

    this.restService.releaseMortgagePlots(requestData).subscribe(
        (response) => {
            this.modalService.dismissAll();
            this.fetchMortgagePlots();
        },
        (error) => {
            this.error = true;
            this.errorMessage = error.status;
        }
    );
}

  releaseMortgagePlot(){

    const requestData = {
      plotIdList: [this.releasingMortgagePlot.plotId]
    };
    this.restService.releaseMortgagePlots(requestData).subscribe((response) => {
        this.modalService.dismissAll();
        this.fetchMortgagePlots();
    },
      (error) => {
        this.error = true;
        this.errorMessage = error.status;
      });

  }

}
